export const visit = (vm, at) => {
at({ "no-no": { "conversations-visitor-experience-components": { "stagedAttachment": { "uploadProgress": "{{uploadedBytes}} av {{totalBytes}}" }, "fileSizeLimit": "Filen kan ikke v\xE6re st\xF8rre enn {{size}}", "screenCapture": "Skjermbilde" } } });
};